// src/Constants/filterOptions.js  
  export const filling = [
    { label: "All", value: "" },
    { label: "Online", value: "online" },
    { label: "Manual", value: "manual" },
    { label: "Service Center", value: "service" },
  ];
  
  export const statusOptions = [
    { label: "All", value: "all" },
    { label: "Pending", value: "pending" },
    { label: "Completed", value: "completed" },
    { label: "SB Filed", value: "sb_filed" },
    { label: "SB Receipt", value: "sb_receipt" },
    { label: "Assessed", value: "assessed" },
    { label: "Goods Receipt", value: "goods_receipt" },
    { label: "Carted", value: "carted" },
    { label: "Examined", value: "examined" },
    { label: "L.E.O", value: "leo" },
    { label: "Stuffing", value: "stuffing" },
    { label: "Hand over to carrier", value: "handover_to_carrier" },
    { label: "Loaded", value: "loaded" },
    { label: "BL Release", value: "bl_release" },
    { label: "EP Copy", value: "ep_copy" },
    { label: "Billing", value: "billing" },
    { label: "Reach at Destination", value: "reach_at_destination" },
    { label: "Delivery to Consignee", value: "delivery_to_consignee" }
  ];

  export const JobNo = [
    { label: "S/B No", value: "SbNo" },
    { label: "AWB/BL No", value: "AWBBLNo" },
    { label: "HAWB/HBL No", value: "HAWBHBLNo" },
    { label: "Invoice No", value: "InvoiceNo" },
    { label: "Container NO", value: "ContainerNo" },
  ];
  
  
  export const Active = [
    { label: "Both", value: "both" },
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];
  
  
  export const taskTypeOptions = [
    { label: "Job No", value: "jobNo" },
    { label: "S/B No", value: "sbno" },
    { label: "AWB/BL No", value: "awbblno" },
    { label: "HAWB/HBL No", value: "hawbno" },
    { label: "Invoice No", value: "invoiceNo" },
    { label: "Container No", value: "containerNo" }, // 🔥 fixed casing
  ];
  